import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAvailableSberPay } from "../store/common/selectors";
import { fetchSberData } from "../api/requests/sber";
import { sberActions } from "../store/features/sberpay/actions";
import { getSberPayBinding, getSberPayContent } from "../store/features/sberpay/selectors";
export var useSberPayment = function useSberPayment() {
  var dispatch = useDispatch();
  var availableSberPay = useSelector(getAvailableSberPay);
  var sberContent = useSelector(getSberPayContent);
  var sberBinding = useSelector(getSberPayBinding);
  React.useEffect(function () {
    if (availableSberPay && !sberContent) {
      fetchSberData().then(function (response) {
        dispatch(sberActions.commonSetter(_objectSpread(_objectSpread({}, response), {}, {
          fetched: true
        })));
      });
    }
  }, [availableSberPay, sberBinding]);
};